var React = require('react');

function TopLeftProblem (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.05","fillRule":"evenodd","clipRule":"evenodd","d":"M132.836 0H72.4584C73.4061 8.09467 75.7584 16.4681 80.534 23.9087C96.6022 48.5526 133.833 53.6378 133.833 53.6378C133.833 53.6378 143.242 24.1695 132.836 0ZM0 212.358V122.701C10.1883 129.59 27.7557 144.074 32.2078 164.361C38.5816 193.404 15.5805 223 15.5805 223C15.5805 223 8.35817 219.275 0 212.358ZM0 19.3216V0H35.7933C36.3273 16.4182 31.9374 30.1675 31.9374 30.1675C31.9374 30.1675 15.6699 27.9456 0 19.3216ZM106.382 116.245C106.382 116.245 70.7181 127.589 45.636 111.551C20.5539 95.9037 15.851 58.3512 15.851 58.3512C15.851 58.3512 51.5146 47.0071 76.5967 63.0452C101.679 79.0833 106.382 116.245 106.382 116.245Z","fill":"white"}));
}

TopLeftProblem.defaultProps = {"width":"138","height":"223","viewBox":"0 0 138 223","fill":"none"};

module.exports = TopLeftProblem;

TopLeftProblem.default = TopLeftProblem;
